export default __webpack_public_path__ + "static/media/work_logo.575f7136.svg";